import {useContext} from 'react'
import BrandsContext from './brands-context'

const useBrands = () => {
  const context = useContext(BrandsContext)
  return context
}

export default useBrands
